"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheControl = void 0;
var handlers_1 = require("./handlers");
function CacheControl() {
    var TTL = 86400000;
    var user = handlers_1.UserCacheHandler(TTL);
    var group = handlers_1.GroupCacheHandler(TTL);
    var widget = handlers_1.WidgetCacheHandler(TTL);
    var template = handlers_1.TemplateCacheHandler(TTL);
    var language = handlers_1.LanguageCacheHandler(TTL);
    var media = handlers_1.MediaCacheHandler(TTL);
    var entry = handlers_1.EntryCacheHandler(TTL);
    var apiKey = handlers_1.ApiKeyCacheHandler(TTL);
    var apiFunction = handlers_1.FunctionCacheHandler(TTL);
    var status = handlers_1.StatusCacheHandler(TTL);
    return {
        user: user,
        group: group,
        widget: widget,
        template: template,
        language: language,
        media: media,
        entry: entry,
        apiKey: apiKey,
        apiFunction: apiFunction,
        status: status,
        clear: function () {
            user.clear();
            group.clear();
            widget.clear();
            template.clear();
            language.clear();
            media.clear();
            entry.clear();
            apiKey.clear();
            apiFunction.clear();
            status.clear();
        },
    };
}
exports.CacheControl = CacheControl;
//# sourceMappingURL=control.js.map